import React from 'react'
import ReactDOM from 'react-dom/client'
import SSFToolkit from './App'
import './index.css'

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <SSFToolkit />
  </React.StrictMode>,
)
